
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/newsroom",
      function () {
        return require("private-next-pages/media/newsroom/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/newsroom"])
      });
    }
  